import React from 'react'
import StencilThickness   from 'pu-react/components/StencilThickness';
import StencilPrinterName   from 'pu-react/components/StencilPrinterName';
import StencilFiducialData from 'pu-react/components/StencilFiducialData';

import FrameSize from '../FrameSize';
import ApertureCount from '../ApertureCount';

const FramedSmtStencil = ({ product, onChangeParameter, parameters, validator }) => {
  return (
    <div className="product-parameters row">
      <div className="col-lg-3">
        <FrameSize
          variants={product.variants}
          parameters={parameters}
          onChangeParameter={onChangeParameter}
          errorMessage={validator.message('Frame Size', parameters.frame_size, 'required')} />
      </div>
      <div className="col-lg-3">
        <ApertureCount
          variants={product.variants}
          parameters={parameters}
          onChangeParameter={onChangeParameter}
          errorMessage={validator.message('Aperture Count', parameters.aperture_count, 'required')} />
      </div>
      <div className="col-lg-3">
        <StencilThickness
          required={true}
          name="stencil_thickness"
          parameters={parameters}
          onChangeParameter={onChangeParameter}
          errorMessage={validator.message('Stencil Thickness', parameters.stencil_thickness, 'required')} />
      </div>
      <div className="col-lg-3">
        <StencilFiducialData
          parameters={parameters}
          onChangeParameter={onChangeParameter}
          errorMessage={validator.message('Fiducial Data', parameters.fiducial_data, 'required')} />
      </div>
      <div className="col-lg-3">
        <StencilPrinterName
          parameters={parameters}
          onChangeParameter={onChangeParameter}
          errorMessage={validator.message('Printer Name', parameters.printer_type, 'required')} />
      </div>
    </div>
  )
}

export default FramedSmtStencil;